import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../components/ui/card";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { useTaal } from "@/contexts/TaalContext";


export default function ResetPasswordPage() {
  const { t } = useTaal();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || password !== confirmPassword) {
      toast.error(t("De wachtwoorden zijn niet gelijk"));
      return;
    }
    if (password.length < 6) {
      toast.error(t("Het wachtwoord moet minstens 6 tekens hebben"));
      return;
    }
    setIsLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      toast.success(t("Wachtwoord hersteld"));
      navigate("/login");
    } catch (error) {
      toast.error(error.response?.data?.detail || t("Wachtwoord herstellen mislukt"));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="text-center">
          <CardTitle className="font-serif text-xl">{t("Wachtwoord herstellen")}</CardTitle>
          <CardDescription>{t("Vul je nieuwe wachtwoord in")}</CardDescription>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="password">{t("Nieuw wachtwoord")}</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="confirm">{t("Wachtwoord bevestigen")}</Label>
              <Input id="confirm" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="••••••••" required />
            </div>
          </CardContent>
          <CardFooter className="flex flex-col gap-3">
            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? t("Herstellen...") : t("Wachtwoord herstellen")}
            </Button>
            <p className="text-xs text-muted-foreground">
              <Link to="/login" className="hover:underline">{t("Terug naar aanmelden")}</Link>
            </p>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
